import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PostEditor } from "@/components/PostEditor";

const searchSchema = z.object({
  template: z.enum(["concept"]).optional(),
  title: z.string().optional(),
  category: z.string().optional(),
  apply: z.preprocess((v) => v === true || v === "true", z.boolean()).optional(),
});

export const Route = createFileRoute("/admin/new")({
  validateSearch: searchSchema,
  component: NewPostPage,
});

function slugifyConcept(input: string) {
  const map: Record<string, string> = { ç: "c", Ç: "c", ğ: "g", Ğ: "g", ı: "i", İ: "i", ö: "o", Ö: "o", ş: "s", Ş: "s", ü: "u", Ü: "u" };
  return input
    .replace(/[çÇğĞıİöÖşŞüÜ]/g, (c) => map[c] ?? c)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}

function NewPostPage() {
  const search = Route.useSearch();
  if (search.template === "concept") {
    const title = search.title?.trim() || "Yeni kavram";
    return (
      <PostEditor
        initial={{
          title_tr: title,
          title_en: title,
          slug: slugifyConcept(title),
          category: search.category || "Other",
          show_on_home: false,
          excerpt_tr: `${title} kavramı için kısa, alıntılanabilir tanım ve bağlam.`,
          content_tr: `<h2>Tanım</h2><p>${title}, sürdürülebilirlik ve finans kesişiminde açıklanması gereken bir kavramdır.</p><h2>Neden önemli?</h2><p></p><h2>Örnekler</h2><p></p><h2>Kaynaklar</h2><p></p>`,
        }}
        autoSaveDraft={search.apply === true}
      />
    );
  }
  return <PostEditor />;
}
